module.exports = __webpack_public_path__ + "static/media/module6_spanish.ccf65bd.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/module6_spanish.mp4
// module id = mEBl
// module chunks = 0